import { SERVICE_ACCOUNT_EXPORT_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { useCallback } from 'react';
import { httpPost } from '../../../../components/utils';
import { useServiceAccountContext } from '../contexts/ServiceAccountContext';
import { ReportType, ServiceAccountExportOptions } from '../ServiceAccountsTypes';
import { useUserContext } from '../../../../context/contexts/UserContext/UserContext';

export interface GenerateReport {
    generateExport: (key: ReportType, isJson: boolean) => Promise<ServiceAccountExportOptions | undefined>;
}

export const useGenerateReport = (): GenerateReport => {
    const { activeFilters, activeTab, tabs } = useServiceAccountContext();

    const { user } = useUserContext();

    const generateExport = useCallback(
        async (key: ReportType, isJson: boolean) => {
            const reportTypeKey = isJson ? 'json' : 'csv';
            const { entitiesFilter } = SERVICE_ACCOUNT_EXPORT_OPTIONS[key].filters[reportTypeKey];

            const exportDataResponse = await httpPost('/ServiceAccountsV2/generateData', {
                type: key,
                filters:
                    key === 'currentFilter'
                        ? {
                              ...activeFilters,
                              type_resolved: activeTab,
                              showRemovedAccounts: tabs[activeTab]?.showRemovedAccounts ? 'true' : 'false'
                          }
                        : {},
                isJson: isJson,
                userData: user,
                entitiesFilter: entitiesFilter || {}
            });

            if (exportDataResponse && exportDataResponse.data) {
                const serviceAccountsExports = Object.assign({}, SERVICE_ACCOUNT_EXPORT_OPTIONS);
                const exportsData = exportDataResponse.data as {};
                Object.keys(exportsData).forEach((key) => {
                    serviceAccountsExports[key] = { ...serviceAccountsExports[key], ...exportsData[key] };
                });
                return serviceAccountsExports;
            }
        },
        [activeFilters, activeTab, tabs, user]
    );

    return { generateExport };
};
